import {gql} from '@apollo/client'
import {POLICY_FIELDS_FRAGMENT} from '../queries/policiesApiQueries'

export const CREATE_POLICY = gql`
  mutation createPolicy($policyData: policy_input!) {
    createPolicy(policyData: $policyData) {
      policy {
        id
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_POLICIES_BY_REFERENCES = gql`
  mutation deletePoliciesByReferences($references: [String!]!, $confirm: Boolean!) {
    deletePoliciesByReferences(references: $references, confirm: $confirm) {
      success
      deletedCount
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_POLICY = gql`
  mutation updatePolicy($id: Int!, $policyData: policy_input!) {
    updatePolicy(id: $id, policyData: $policyData) {
      success
      errors {
        message
      }
    }
  }
`

export const CANCEL_POLICY = gql`
  mutation cancelPolicy($id: Int!, $cancellationDate: Date) {
    cancelPolicy(id: $id, cancellationDate: $cancellationDate) {
      success
      errors {
        message
      }
    }
  }
`

export const COMPLETE_POLICY = gql`
  mutation completePolicy($id: Int!) {
    completePolicy(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const BLOCK_POLICY = gql`
  mutation blockPolicy($id: Int!) {
    blockPolicy(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const MARK_POLICIES_PAID = gql`
  mutation markPoliciesAsPaid($policyIds: [Int!]!, $paidAt: DateTime) {
    markPoliciesAsPaid(policyIds: $policyIds, paidAt: $paidAt) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const UNPAID_TO_ADVISOR = gql`
  mutation unpaidToAdvisor($policyIds: [Int!]!) {
    unpaidToAdvisor(policyIds: $policyIds) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const CHARGEBACK_TO_ADVISOR = gql`
  mutation chargebackToAdvisor($policyIds: [Int!]!, $chargebackAt: DateTime!) {
    chargebackToAdvisor(policyIds: $policyIds, chargebackAt: $chargebackAt) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const UNCHARGEBACK_TO_ADVISOR = gql`
  mutation unchargebackToAdvisor($policyIds: [Int!]!) {
    unchargebackToAdvisor(policyIds: $policyIds) {
      success
      processedCount
      skippedCount
      errors {
        message
      }
    }
  }
`

export const DUPLICATE_POLICY = gql`
  mutation duplicatePolicy($id: Int!, $statusOption: String, $typePolicy: Int) {
    duplicatePolicy(id: $id, statusOption: $statusOption, typePolicy: $typePolicy) {
      success
      errors {
        field
        message
      }
      policy {
        id
        policyName
        status
        effectiveDate
      }
    }
  }
`

export const ADD_MEMBER_ID_POLICY = gql`
  mutation assignMemberIdToPolicy($id: ID!, $memberId: String!) {
    assignMemberIdToPolicy(id: $id, memberId: $memberId) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_DOCUMENT_POLICY_STR = `
  mutation createAttachments($attachmentsData: attachments_input!) {
    createAttachments(attachmentsData: $attachmentsData) {
      success
      errors {
        message
      }
    }
  }
`

export const EDIT_DOCUMENT_POLICY_STR = `
  mutation updateAttachments($attachmentsData: attachments_input!, $id: Int!) {
    updateAttachments(attachmentsData: $attachmentsData, id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const DELETE_FILE_POLICY = gql`
  mutation deleteAttachments($id: Int!) {
    deleteAttachments(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const ADD_NOTE_POLICY = gql`
  mutation createPolicyNote($policyNoteData: policy_note_input!) {
    createPolicyNote(policyNoteData: $policyNoteData) {
      success
      errors {
        message
      }
    }
  }
`

export const GET_NOTES_POLICY = gql`
  query policyNotesByPolicy($policyId: Int) {
    policyNotesByPolicy(policyId: $policyId) {
      id
      comments
      created
      user {
        id
        firstName
        lastName
      }
      urgent
    }
  }
`

export const UPDATE_POLICY_FULL = gql`
  mutation updatePolicyFull(
    $id: Int!
    $policyData: policy_input!
    $membersToCreate: [member_policy_input]
    $membersToUpdate: [member_policy_update_input]
    $membersToDelete: [ID]
    $paymentData: policy_payment_input
    $extraInfoData: policy_extra_info_input
    $lifeDetailData: policy_life_detail_input
    $medicationsToCreate: [policy_life_medication_input]
    $medicationsToUpdate: [policy_life_medication_input]
    $medicationsToDelete: [ID]
  ) {
    updatePolicyFull(
      id: $id
      policyData: $policyData
      membersToCreate: $membersToCreate
      membersToUpdate: $membersToUpdate
      membersToDelete: $membersToDelete
      paymentData: $paymentData
      extraInfoData: $extraInfoData
      lifeDetailData: $lifeDetailData
      medicationsToCreate: $medicationsToCreate
      medicationsToUpdate: $medicationsToUpdate
      medicationsToDelete: $medicationsToDelete
    ) {
      success
      errors {
        field
        message
      }
      policy {
        ...PolicyFields
      }
    }
  }
  ${POLICY_FIELDS_FRAGMENT}
`

export const REQUEST_POLICY_ASSIGNMENT = gql`
  mutation requestPolicyAssignment($policyId: Int!, $reason: String) {
    requestPolicyAssignment(policyId: $policyId, reason: $reason) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_POLICIES_BY_CARRIER_STR = `
  mutation updatePoliciesByCarrier(
    $carrierId: ID!
    $targetCarrierIds: [ID]!
    $policyTypeIds: [ID]!
    $policyDateFrom: Date!
    $policyDateTo: Date!
    $dateCriteria: String!
    $asOfDate: Date!
    $file: Upload!
  ) {
    updatePoliciesByCarrier(
      carrierId: $carrierId
      targetCarrierIds: $targetCarrierIds
      policyTypeIds: $policyTypeIds
      policyDateFrom: $policyDateFrom
      policyDateTo: $policyDateTo
      dateCriteria: $dateCriteria
      asOfDate: $asOfDate
      file: $file
    ) {
      success
      message
      processedCount
      matchedCount
      unmatchedCount
      errorsCount
      unmatchedRows {
        rowNumber
        memberId
        name
        reason
        rawRowJson
        carrierStatusRaw
        carrierStatusGeneric
        systemPolicyStatus
        systemAgentName
        systemAgentEmail
      }
    }
  }
`

// Async version — same arguments, returns a task to poll instead of blocking.
export const UPDATE_POLICIES_BY_CARRIER_ASYNC_STR = `
  mutation updatePoliciesByCarrierAsync(
    $carrierId: ID!
    $targetCarrierIds: [ID]!
    $policyTypeIds: [ID]!
    $policyDateFrom: Date!
    $policyDateTo: Date!
    $dateCriteria: String!
    $asOfDate: Date!
    $file: Upload!
  ) {
    updatePoliciesByCarrierAsync(
      carrierId: $carrierId
      targetCarrierIds: $targetCarrierIds
      policyTypeIds: $policyTypeIds
      policyDateFrom: $policyDateFrom
      policyDateTo: $policyDateTo
      dateCriteria: $dateCriteria
      asOfDate: $asOfDate
      file: $file
    ) {
      success
      message
      task {
        taskId
        status
        progressPercentage
        progressMessage
      }
    }
  }
`

export const REASSIGN_POLICIES_USER = gql`
  mutation assignPoliciesToUser(
    $fromUserId: Int
    $policyName: String
    $isImportant: Boolean
    $archived: Boolean
    $hasReminders: Boolean
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $advisorPaid: Boolean
    $advisorChargeback: Boolean
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $carrier: [String]
    $insuranceCategory: String
    $policyType: [String]
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $stateEu: [String]
    $stateJurisdictionType: String
    $status: [String]
    $paymentStatus: [String]
    $documentStatus: [String]
    $leadSource: [String]
    $signatureForm: [String]
    $signatureStatus: String
    $agentOfRecord: [String]
    $immigrationStatus: [String]
    $holderGender: String
    $metalLevel: String
    $createdAfter: Date
    $createdBefore: Date
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $paymentStatusDateAfter: Date
    $paymentStatusDateBefore: Date
    $advisorPaidDateAfter: Date
    $advisorPaidDateBefore: Date
    $advisorChargebackDateAfter: Date
    $advisorChargebackDateBefore: Date
    $canceledAfter: Date
    $canceledBefore: Date
    $completedAfter: Date
    $completedBefore: Date
    $effectiveYear: [String]
    $holderName: String
    $memberName: String
    $carrierStatusGeneric: [String]
    $carrierStatusRaw: String
    $carrierLastAsOfDateAfter: Date
    $carrierLastAsOfDateBefore: Date
    $carrierIsAgeIn: Boolean
    $carrierIsDelinquent: Boolean
    $carrierIsUnpaidPending: Boolean
    $carrierIsUnpaidPastDue: Boolean
    $toUserId: Int
    $toUserIds: [Int]
    $toGroupId: Int
    $policyIds: [Int]
  ) {
    assignPoliciesToUser(
      fromUserId: $fromUserId
      policyName: $policyName
      isImportant: $isImportant
      archived: $archived
      hasReminders: $hasReminders
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      advisorPaid: $advisorPaid
      advisorChargeback: $advisorChargeback
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      carrier: $carrier
      insuranceCategory: $insuranceCategory
      policyType: $policyType
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      stateEu: $stateEu
      stateJurisdictionType: $stateJurisdictionType
      status: $status
      paymentStatus: $paymentStatus
      documentStatus: $documentStatus
      leadSource: $leadSource
      signatureForm: $signatureForm
      signatureStatus: $signatureStatus
      agentOfRecord: $agentOfRecord
      immigrationStatus: $immigrationStatus
      holderGender: $holderGender
      metalLevel: $metalLevel
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      effectiveDateAfter: $effectiveDateAfter
      effectiveDateBefore: $effectiveDateBefore
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      paymentStatusDateAfter: $paymentStatusDateAfter
      paymentStatusDateBefore: $paymentStatusDateBefore
      advisorPaidDateAfter: $advisorPaidDateAfter
      advisorPaidDateBefore: $advisorPaidDateBefore
      advisorChargebackDateAfter: $advisorChargebackDateAfter
      advisorChargebackDateBefore: $advisorChargebackDateBefore
      canceledAfter: $canceledAfter
      canceledBefore: $canceledBefore
      completedAfter: $completedAfter
      completedBefore: $completedBefore
      effectiveYear: $effectiveYear
      holderName: $holderName
      memberName: $memberName
      carrierStatusGeneric: $carrierStatusGeneric
      carrierStatusRaw: $carrierStatusRaw
      carrierLastAsOfDateAfter: $carrierLastAsOfDateAfter
      carrierLastAsOfDateBefore: $carrierLastAsOfDateBefore
      carrierIsAgeIn: $carrierIsAgeIn
      carrierIsDelinquent: $carrierIsDelinquent
      carrierIsUnpaidPending: $carrierIsUnpaidPending
      carrierIsUnpaidPastDue: $carrierIsUnpaidPastDue
      toUserId: $toUserId
      toUserIds: $toUserIds
      toGroupId: $toGroupId
      policyIds: $policyIds
    ) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_POLICIES_STATUS = gql`
  mutation updatePoliciesStatus(
    $newStatus: String
    $newPaymentStatus: String
    $newDocumentStatus: String
    $newPolicyType: Int
    $newCarrier: Int
    $policyName: String
    $isImportant: Boolean
    $archived: Boolean
    $hasReminders: Boolean
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $advisorPaid: Boolean
    $advisorChargeback: Boolean
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $carrier: [String]
    $insuranceCategory: String
    $policyType: [String]
    $user: [String]
    $assignedTo: [String]
    $zipCode: String
    $stateEu: [String]
    $stateJurisdictionType: String
    $status: [String]
    $paymentStatus: [String]
    $documentStatus: [String]
    $leadSource: [String]
    $signatureForm: [String]
    $signatureStatus: String
    $agentOfRecord: [String]
    $immigrationStatus: [String]
    $holderGender: String
    $metalLevel: String
    $createdAfter: Date
    $createdBefore: Date
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $documentsDueDateAfter: Date
    $documentsDueDateBefore: Date
    $paymentStatusDateAfter: Date
    $paymentStatusDateBefore: Date
    $advisorPaidDateAfter: Date
    $advisorPaidDateBefore: Date
    $advisorChargebackDateAfter: Date
    $advisorChargebackDateBefore: Date
    $canceledAfter: Date
    $canceledBefore: Date
    $completedAfter: Date
    $completedBefore: Date
    $effectiveYear: [String]
    $holderName: String
    $memberName: String
    $carrierStatusGeneric: [String]
    $carrierStatusRaw: String
    $carrierLastAsOfDateAfter: Date
    $carrierLastAsOfDateBefore: Date
    $carrierIsAgeIn: Boolean
    $carrierIsDelinquent: Boolean
    $carrierIsUnpaidPending: Boolean
    $carrierIsUnpaidPastDue: Boolean
    $policyIds: [Int]
  ) {
    updatePoliciesStatus(
      newStatus: $newStatus
      newPaymentStatus: $newPaymentStatus
      newDocumentStatus: $newDocumentStatus
      newPolicyType: $newPolicyType
      newCarrier: $newCarrier
      policyName: $policyName
      isImportant: $isImportant
      archived: $archived
      hasReminders: $hasReminders
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      advisorPaid: $advisorPaid
      advisorChargeback: $advisorChargeback
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      carrier: $carrier
      insuranceCategory: $insuranceCategory
      policyType: $policyType
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      stateEu: $stateEu
      stateJurisdictionType: $stateJurisdictionType
      status: $status
      paymentStatus: $paymentStatus
      documentStatus: $documentStatus
      leadSource: $leadSource
      signatureForm: $signatureForm
      signatureStatus: $signatureStatus
      agentOfRecord: $agentOfRecord
      immigrationStatus: $immigrationStatus
      holderGender: $holderGender
      metalLevel: $metalLevel
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      effectiveDateAfter: $effectiveDateAfter
      effectiveDateBefore: $effectiveDateBefore
      documentsDueDateAfter: $documentsDueDateAfter
      documentsDueDateBefore: $documentsDueDateBefore
      paymentStatusDateAfter: $paymentStatusDateAfter
      paymentStatusDateBefore: $paymentStatusDateBefore
      advisorPaidDateAfter: $advisorPaidDateAfter
      advisorPaidDateBefore: $advisorPaidDateBefore
      advisorChargebackDateAfter: $advisorChargebackDateAfter
      advisorChargebackDateBefore: $advisorChargebackDateBefore
      canceledAfter: $canceledAfter
      canceledBefore: $canceledBefore
      completedAfter: $completedAfter
      completedBefore: $completedBefore
      effectiveYear: $effectiveYear
      holderName: $holderName
      memberName: $memberName
      carrierStatusGeneric: $carrierStatusGeneric
      carrierStatusRaw: $carrierStatusRaw
      carrierLastAsOfDateAfter: $carrierLastAsOfDateAfter
      carrierLastAsOfDateBefore: $carrierLastAsOfDateBefore
      carrierIsAgeIn: $carrierIsAgeIn
      carrierIsDelinquent: $carrierIsDelinquent
      carrierIsUnpaidPending: $carrierIsUnpaidPending
      carrierIsUnpaidPastDue: $carrierIsUnpaidPastDue
      policyIds: $policyIds
    ) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

export const SYNC_POLICY_TO_HEALTH_SHERPA = gql`
  mutation syncPolicyToMedicareHealthsherpa($policyId: Int!) {
    syncPolicyToMedicareHealthsherpa(policyId: $policyId) {
      success
      message
      healthsherpaContactId
      errors {
        message
      }
    }
  }
`
